export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5206.ceeb37e6.jpg";